/**
 * ボディタイプアイコンの URL を解決する。
 *
 * アイコンのファイル名は body_sub_cd で、燃料違いのタブは
 * assets/image/body-type/ 配下のサブディレクトリ(hv/ ev/ phev/)に分かれている。
 * 同じ分岐が3ファイル(CatalogSearch 配下の2コンポーネントとボディタイプ選択画面)に
 * 重複していたため、ここに一本化する。
 *
 * ビルド時に Vite がアセットを収集できるよう、new URL の動的パスではなく
 * import.meta.glob で URL を静的に解決する。
 */
const BODY_TYPE_ICON_URLS = import.meta.glob<string>(
  '../assets/image/body-type/**/*.svg',
  { query: '?url', import: 'default', eager: true }
)

/** body_sub_cd が未設定、またはアイコンが存在しない場合に使う代替画像 */
const FALLBACK_ICON_URL = new URL(
  '../assets/image/brands/logo/0000.webp',
  import.meta.url
).href

/**
 * @param iconDir - タブ定義が持つサブディレクトリ(末尾スラッシュ込み。ボディタイプタブは空文字)
 * @param bodySubCd - アイコンのファイル名にあたる body_sub_cd
 */
export const resolveBodyTypeIconUrl = (
  iconDir: string,
  bodySubCd: string | undefined
): string => {
  if (!bodySubCd) {
    return FALLBACK_ICON_URL
  }
  return (
    BODY_TYPE_ICON_URLS[
      `../assets/image/body-type/${iconDir}${bodySubCd}.svg`
    ] ?? FALLBACK_ICON_URL
  )
}
